"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function UploadIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "4.5", y: "2.879", width: "15", height: "1.7" }),
        react_1.default.createElement("rect", { x: "8.753", y: "19.575", width: "6.492", height: "1.546" }),
        react_1.default.createElement("path", { d: "M11.672,7.248a.5.5,0,0,1,.662,0l6.476,5.985a.43.43,0,0,1-.331.739h-3.23V18.4h-6.5V13.972H5.524a.429.429,0,0,1-.463-.394.434.434,0,0,1,.131-.345Z" })));
}
exports.default = UploadIcon;
